export default {
   "No mood data in selected range": "Aucune donnée de humeur dans la plage sélectionnée",
}
